import React from 'react';
import { AuthProvider } from "./config/AuthContext";
import AppRoutes from "./newView/routes/AppRoutes";
import { ConfigProvider, theme, FloatButton } from "antd";
import { ThemeProvider, useTheme } from "./config/ThemeContext";
import { BulbOutlined, BulbFilled } from '@ant-design/icons';

const AppContent = () => {
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <ConfigProvider
            theme={{
                algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
            }}
        >
            <AuthProvider>
                <AppRoutes />
                {/*<FloatButton
                    icon={isDarkMode ? <BulbFilled /> : <BulbOutlined />}
                    onClick={toggleTheme}
                    style={{ right: 24, bottom: 84 }}
                    type="primary"
                    tooltip="Canviar Tema"
                />*/}
            </AuthProvider>
        </ConfigProvider>
    );
};

function Root() {
    return (
        <ThemeProvider>
            <AppContent />
        </ThemeProvider>
    );
}

export default Root;
